import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import withStyles from '@material-ui/core/styles/withStyles';

import ScrollableContainer from '../../../utility/ScrollableContainer';

import SearchLayers from './SearchLayers';
import AdditionalLayerDropdown from './AdditionalLayerDropdown';
import PlanningIcon from '../../../CartoLib/Icons/Planning';
import PropertyAndStructuresIcon from '../../../CartoLib/Icons/PropertyAndStructures';
import LocalDevelopmentPlansIcon from '../../../CartoLib/Icons/LocalDevelopmentPlans';
import Title from '../Title';
import LayerQuickSelect from './LayerQuickSelect';
import SiteCardsQuickSelect from './SiteCardsQuickSelect';

import { groupBy } from 'lodash';

class Layers extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired
    };

    constructor (props) {
        super(props);
    }

    shouldComponentUpdate (nextProps, nextState) {
        return (this.props.layers.length != nextProps.layers.length);
    }

    sortPrimaryLayers () {
        const { layers } = this.props;
        const primaryLayers = layers.filter(layer => layer.primary_layer);
        // const sortedPrimaryLayers = {};
        // for (const layer of primaryLayers) {
        //     sortedPrimaryLayers[layer.category] = sortedPrimaryLayers[layer.category] ?
        //         [ ...sortedPrimaryLayers[layer.category], layer ] : [ layer ]
        // }
        return primaryLayers;
    }

    // sortPrimaryLayers() {
    //     const { layers } = this.props;
    //     const primaryLayers = layers.filter(layer => layer.primary_layer);
    //     const sortedPrimaryLayers = {};
    //     for (const layer of primaryLayers) {
    //         sortedPrimaryLayers[layer.category] = sortedPrimaryLayers[layer.category] ?
    //             [ ...sortedPrimaryLayers[layer.category], layer ] : [ layer ]
    //     }
    //     return sortedPrimaryLayers;
    // }

    sortAdditionalLayers () {
        const { layers } = this.props;
        const additionalLayers = layers.filter(layer => !layer.primary_layer);
        const sortedAdditionalLayers = groupBy(additionalLayers, (l) => l.category);
        return sortedAdditionalLayers;
    }

    render () {
        const { classes, layers } = this.props;
        const sortedPrimaryLayers = this.sortPrimaryLayers();
        const sortedAdditionalLayers = this.sortAdditionalLayers();
        // ToDo If primary layer then do this rather than hard coded
        return (
            <ScrollableContainer>
                <div className={classes.root}>
                    <Title title="QUICK SELECT" />
                    <SiteCardsQuickSelect />
                    <LayerQuickSelect
                        layer={layers.find(l => l.system_name === 'hmlr_land_parcels')}
                    />
                    <LayerQuickSelect
                        layer={layers.find(l => l.system_name === 'planning_applications')}
                    />
                    <LayerQuickSelect
                        layer={layers.find(l => l.system_name === 'hmlr_price_paid')}
                    />
                    <Title title="ALL LAYERS" />
                    <SearchLayers />
                    <AdditionalLayerDropdown
                        additionalLayers={sortedAdditionalLayers}
                    />
                </div>
            </ScrollableContainer>
        );
    }
}

const style = theme => ({
    root: {
        padding: theme.constants.spacing.xl,
        '&> *:not(:last-child)':{
            marginBottom: theme.constants.verticalMargin
        }
    },
    primaryLayers: {
        padding: '30px 0 0 0',
        '& > div:last-child div': {
            marginBottom: '0 !important'
        }
    }
});

const mapStateToProps = state => {
    return {
        layers: state.layers.layers.filter(el => el.display)
    };
};

const mapDispatchToProps = dispatch => ({

});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(Layers);